import React from 'react';
import useArticleStore from './stores/useArticleStore';

function ProgressBar() {
  var titleId = useArticleStore(function(s) { return s.title_id; });
  var contentId = useArticleStore(function(s) { return s.content_id; });
  var image = useArticleStore(function(s) { return s.image; });
  var imageUrl = useArticleStore(function(s) { return s.image_url; });
  var ownerableId = useArticleStore(function(s) { return s.ownerable_id; });
  var doctorId = useArticleStore(function(s) { return s.doctor_id; });
  var tagList = useArticleStore(function(s) { return s.tag_list; });
  var categoryList = useArticleStore(function(s) { return s.category_list; });
  var metaDescription = useArticleStore(function(s) { return s.meta_description; });
  var metaKeywords = useArticleStore(function(s) { return s.meta_keywords; });

  function hasContent(html) {
    if (!html) return false;
    var stripped = html.replace(/<[^>]*>/g, '').trim();
    return stripped.length > 0;
  }

  var progress = 0;
  if (titleId) progress += 15;
  if (hasContent(contentId)) progress += 15;
  if (image || imageUrl) progress += 15;
  if (ownerableId) progress += 10;
  if (doctorId) progress += 10;
  if (tagList && tagList.length > 0) progress += 10;
  if (categoryList && categoryList.length > 0) progress += 10;
  if (metaDescription) progress += 10;
  if (metaKeywords) progress += 5;

  return (
    <div className="article-form-new__progressbar">
      <div className="article-form-new__progressbar-track">
        <div
          className={'article-form-new__progressbar-fill' + (progress >= 100 ? ' article-form-new__progressbar-fill--complete' : '')}
          style={{ width: progress + '%' }}
        />
      </div>
      <span className="article-form-new__progressbar-label">
        {progress}%
      </span>
    </div>
  );
}

export default ProgressBar;
